const PALETTE = [
  "bg-violet-500 text-white",
  "bg-indigo-500 text-white",
  "bg-blue-500 text-white",
  "bg-sky-500 text-white",
  "bg-teal-500 text-white",
  "bg-emerald-500 text-white",
  "bg-amber-500 text-white",
  "bg-orange-500 text-white",
  "bg-rose-500 text-white",
  "bg-fuchsia-500 text-white",
];

// Text-color twin of PALETTE, index-aligned so the same seed always lands on the same hue —
// a sender's name label and their avatar fallback must visibly agree.
const TEXT_PALETTE = [
  "text-violet-600 dark:text-violet-400",
  "text-indigo-600 dark:text-indigo-400",
  "text-blue-600 dark:text-blue-400",
  "text-sky-600 dark:text-sky-400",
  "text-teal-600 dark:text-teal-400",
  "text-emerald-600 dark:text-emerald-400",
  "text-amber-600 dark:text-amber-400",
  "text-orange-600 dark:text-orange-400",
  "text-rose-600 dark:text-rose-400",
  "text-fuchsia-600 dark:text-fuchsia-400",
];

// Concrete-color twin of PALETTE's backgrounds, index-aligned, for surfaces CSS classes can't reach
// (the initials icon drawn onto a canvas for OS notifications). `css` mirrors the Tailwind 500 shade
// in tailwindcss/theme.css (pinned by avatar-color.test.js); `hex` is its sRGB fallback for a canvas
// that rejects oklch().
const FILL_PALETTE = [
  { css: "oklch(60.6% 0.25 292.717)", hex: "#8e51ff" }, // violet-500
  { css: "oklch(58.5% 0.233 277.117)", hex: "#615fff" }, // indigo-500
  { css: "oklch(62.3% 0.214 259.815)", hex: "#2b7fff" }, // blue-500
  { css: "oklch(68.5% 0.169 237.323)", hex: "#00a6f4" }, // sky-500
  { css: "oklch(70.4% 0.14 182.503)", hex: "#00bba7" }, // teal-500
  { css: "oklch(69.6% 0.17 162.48)", hex: "#00bc7d" }, // emerald-500
  { css: "oklch(76.9% 0.188 70.08)", hex: "#fe9a00" }, // amber-500
  { css: "oklch(70.5% 0.213 47.604)", hex: "#ff6900" }, // orange-500
  { css: "oklch(64.5% 0.246 16.439)", hex: "#ff2056" }, // rose-500
  { css: "oklch(66.7% 0.295 322.15)", hex: "#e12afb" }, // fuchsia-500
];

function paletteIndex(seed) {
  const s = String(seed || "").trim().toLowerCase();
  if (!s) return -1;
  let h = 5381;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % PALETTE.length;
}

export function getAvatarColorClasses(seed) {
  const idx = paletteIndex(seed);
  if (idx < 0) return "bg-muted text-muted-foreground";
  return PALETTE[idx];
}

/**
 * Foreground-only variant for coloring a sender's NAME with the same per-seed hue as their
 * avatar fallback (used by WhatsApp-group bubbles, where per-sender identity is the only way to
 * tell participants apart). Same hash as {@link getAvatarColorClasses}.
 */
export function getSenderNameColorClasses(seed) {
  const idx = paletteIndex(seed);
  if (idx < 0) return "text-primary";
  return TEXT_PALETTE[idx];
}

/**
 * The seed's avatar background as concrete colors (same hash as {@link getAvatarColorClasses}),
 * or null for an empty seed — the class version's muted fallback has no fixed color to give.
 * @returns {{ css: string, hex: string } | null}
 */
export function getAvatarFillColor(seed) {
  const idx = paletteIndex(seed);
  if (idx < 0) return null;
  return FILL_PALETTE[idx];
}
